module.exports = __webpack_public_path__ + "static/signature-ace98270ab4991990cd8a959b5f683d0.svg";